import { makeObservable, observable, action, toJS, runInAction } from "mobx";
import M from "moment";
import { webAPI } from "../api/Api";
import { SearchRequest } from "../api/Types";
import DefectFormApi from "../api/DefectForm";
import { PerPageSettings, WithBooleanFlag, Sorter, StatusInfo } from "./core";
import Constants from "../constants/Common";
import { downloadRawFileFromServer } from "../api/helpers";
import defectFilterFieldStore from "./defectFilterFields";
import { SortingDirection } from "../constants/Enums";
import { DEFAULT_GRID_TYPE } from "../components/DefectForm/constants";
import { message } from "antd";

class DefectData {
  data = [];
  paginator = new PerPageSettings();
  isLoading = new WithBooleanFlag();
  filter = defectFilterFieldStore;
  sorter = new Sorter();

  dataLable = "Реестр дефектов";

  uploadDefectFileIsSending = new WithBooleanFlag(false);
  fillDefectStatus = new StatusInfo();
  fillDefectError: string[] = [];
  uploadDefectFileIsOpened = new WithBooleanFlag(false);
  downloadInProgress = new WithBooleanFlag(false);
  downloadDedectTemplateIsOpened = new WithBooleanFlag(false);

  constructor() {
    makeObservable(
      this,
      {
        data: observable,
        allData: action,
        uploadDefectFile: action,
        fillDefectError: observable,
        closeUploadDefectFile: action,
        downloadDedectTemplate: action,
        downloadDefectToXls: action,
        closedownloadDedectPopup: action,
      },
      {
        deep: true,
      },
    );
    this.sorter.setSortData("id", SortingDirection.Desc);
  }

  allData = async () => {
    this.isLoading.setTrue();
    try {
      const request: SearchRequest = {
        page: this.paginator.page,
        count: this.paginator.perPage,
        sortItems: this.sorter.sortData,
        filterItems: [...this.filter.filterItems].reduce((acc, curr) => {
          const idx = acc.findIndex(
            (item) => item.fieldName === curr.fieldName,
          );
          if (idx > -1) {
            acc[idx] = curr;
          } else {
            acc.push(curr);
          }
          return acc;
        }, []),
      };

      const res = await webAPI.post(`/sp/event/search`, {
        ...request,
      });
      runInAction(() => {
        this.data = res.data.items;
        this.paginator.updateMeta(res.data);
      });
    } catch (e) {
      console.log(e);
    } finally {
      this.isLoading.setFalse();
    }
    return toJS(this.data);
  };

  async uploadDefectFile(values) {
    this.uploadDefectFileIsSending.setTrue();
    this.fillDefectStatus.resetStatus();

    try {
      const res = await DefectFormApi.uploadDefectFile(values);
      this.fillDefectStatus.setStatus(Constants.requestStatuses.uploadSuccess);
      await this.allData();
    } catch (e) {
      this.fillDefectError = this.fillDefectStatus.getDetailsFromError(e);
      this.fillDefectStatus.setDetails(e);
      this.fillDefectStatus.setStatus(Constants.requestStatuses.error);
      this.uploadDefectFileIsOpened.setTrue();
      // this.allData();
    } finally {
      this.uploadDefectFileIsSending.setFalse();
    }
  }

  closeUploadDefectFile() {
    this.uploadDefectFileIsOpened.setFalse();
    this.fillDefectStatus.resetStatus();
  }

  async downloadDedectTemplate(gridTypeId) {
    try {
      const res = await DefectFormApi.exportTemplate(gridTypeId);
      const gridType = DEFAULT_GRID_TYPE.find(
        (i) => i.gridTypeId === gridTypeId,
      );
      const dt = M(new Date()).format("YYYY-MM-DD_HH-mm");
      downloadRawFileFromServer(
        res.data,
        gridType ? `${gridType?.gridTitle}_${dt}.xlsx` : `Тип сети_${dt}.xlsx`,
      );
    } catch (e) {
      console.log(e);
    }
  }

  closedownloadDedectPopup() {
    this.downloadDedectTemplateIsOpened.setFalse();
  }

  downloadDefectToXls = async () => {
    try {
      const request: SearchRequest = {
        page: this.paginator.page,
        count: this.paginator.total,
        sortItems: this.sorter.sortData,
        filterItems: [
          ...(this.filterItems || []),
          ...this.filter.filterItems,
        ].reduce((acc, curr) => {
          const idx = acc.findIndex(
            (item) => item.fieldName === curr.fieldName,
          );
          if (idx > -1) {
            acc[idx] = curr;
          } else {
            acc.push(curr);
          }
          return acc;
        }, []),
      };
      //const res = await DefectFormApi.exportExcel(request);

      //downloadRawFileFromServer(res.data, `${this.dataLable}.xlsx`);
      const res = await DefectFormApi.exportExcelThread(request);
      if (res && res.status == 204) {
        message.success(Constants.statusMessage.downloadRequestSent);
      } else {
        message.error(Constants.statusMessage.error);
      }
    } catch (e) {
      console.log(e);
    }
  };
}

export default DefectData;
